module.exports = "\r\n  <router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layouts/clientes/clientes-layout.component.html
// module id = ./src/app/modules/layouts/clientes/clientes-layout.component.html
// module chunks = main